(function() {
    'use strict';
    
a3_cabin_reports.factory('ReportGuidFactory', ReportGuidFactory);
    
    /**
    * @memberof CabinReports
    * @ngdoc factory
    * @name ReportGuidFactory
    * @description 
    *   Manages ReportGuid
    * @ngInject
    */
function ReportGuidFactory(localStorageMD5Service,GenericService) {

        /**
        * Initialize the ReportGuid
        * @memberof ReportGuidFactory
        */
		function ReportGuid() {
			this.Guid = null;
		}
		var objType = 'reportGuids';
		var objCallback = ReportGuid;  

		var service = 
		{  
			getNextGuid : getNextGuid,
			setReportGuidsToStorage : setReportGuidsToStorage,
			restoreGuid : restoreGuid,
			getRemainingReportGuids : getRemainingReportGuids
		};
		
        /**
         * Extend Object from the default ReportGuid Object
         * @memberof ReportGuidFactory
         * @param {Object} obj  a ReportGuid
         * @returns {Object} ReportGuid
         */
		function fromObject(obj){
			if (obj == null) return null;
			var reportGuid = new ReportGuid();
			reportGuid.Guid = obj;
			return reportGuid;
		};

       /**
         * Extend an array of Objects from the default ReportGuid Object
         * @memberof ReportGuidFactory
         * @param {Array} objList  an Array Of ReportGuids
         * @returns {Array} ReportGuids
         */
		function fromObjectList(objList) {
			if (objList == null) return null;

			var arrayLength = objList.length;
			var reportGuids = new Array();

			for (var i = 0; i < arrayLength; i++) {
				var reportGuid = new ReportGuid();
				reportGuid.Guid = objList[i];
				reportGuids.push(reportGuid);
			}

			return reportGuids;
		};
			
        /**
         * Get all the ReportGuid's guid from given list
         * @memberof ReportGuidFactory
         * @param {array} objectList An object list
         * @returns {array} guids
         */
		function toObjectList(guidList) {
			if (guidList == null) return null;

			var arrayLength = guidList.length;
			var objList = new Array();

			for (var i = 0; i < arrayLength; i++) {
				objList.push(guidList[i].Guid);
			}

			return objList;
		};

        /**
         * Get all the reportGuid objects
         * @memberof reportGuid
         * @returns {array} ACSupplies
         */
		function getReportGuidsFromStorage() {
			var reportGuids = localStorageMD5Service.get('reportGuids');
			return fromObjectList(reportGuids);
		}

        /**
         * Set all the reportGuid objects
         * @memberof ReportGuidFactory
         * @return {string} reportGuid
         */
		function setReportGuidsToStorage(reportGuids) {
			GenericService.saveAll(reportGuids,objType,objCallback);
		}

         /**
         * Delete all the reportGuid objects
         * @memberof ReportGuidFactory
         */
		function clearReportGuidsFromStorage() {
			GenericService.removeAll(objType,objCallback);
		}

        /**
         * Get the next available guid and remove it from pool
         * @memberof ReportGuidFactory
         * @return {string} reportGuid
         */
		function getNextGuid() {
			var reportGuids = getReportGuidsFromStorage();
			if (reportGuids == null)
				return null;

			var validGuidIndex = -1;
			var resultingGuid = null;

			for (var i = 0; i < reportGuids.length; i++) {
				if (reportGuids[i].Guid != null && reportGuids[i].Guid != '') {
					validGuidIndex = i;
					resultingGuid = reportGuids[i].Guid;
					break;
				}
			}

			if (validGuidIndex >= 0) {
				// remove the guid from the array
				reportGuids.splice(validGuidIndex, 1);

				// save the new array
				 setReportGuidsToStorage(toObjectList(reportGuids));
			}

			return resultingGuid;
		}

         /**
         * Restore previously used guid into the pool of guids,Used when a report is being cancelled or deleted (and it has not been sent to the server)
         * @memberof ReportGuidFactory
         * @param {string} reportGuid
         */
		function restoreGuid(guid) {
			//reject incorrect values
			if (typeof guid == 'undefined' || guid == null || guid == '')
				return false;
			var reportGuids = getReportGuidsFromStorage();
			if (reportGuids == null)
				reportGuids = [];

			var arrayLength = reportGuids.length;
			for (var i = 0; i < arrayLength; i++) {
				if (reportGuids[i].Guid == guid) {
					return false;
				}
			}

			//add the guid into the pool of guids
			var repGuid = fromObject(guid);
			reportGuids.push(repGuid);

			// save the new array
			setReportGuidsToStorage(toObjectList(reportGuids));

			return true;
		}

        /**
         * Get the  count of remaining reportGuid objects
         * @memberof reportGuid
         * @returns {number} reportGuidsLength
         */
		function getRemainingReportGuids() {
			var reportGuids = getReportGuidsFromStorage();
			if (reportGuids == null)
				return 0;

			return reportGuids.length;
		}

	return service;
	}

})();